import { render } from "./JoinNowMemberStep04Email.vue?vue&type=template&id=a6b0a654&scoped=true"
import script from "./JoinNowMemberStep04Email.vue?vue&type=script&lang=js"
export * from "./JoinNowMemberStep04Email.vue?vue&type=script&lang=js"

import "./JoinNowMemberStep04Email.vue?vue&type=style&index=0&id=a6b0a654&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6b0a654"]])

export default __exports__